import { DialogsActions } from '../actions/dialogsActions';
import { RootActions } from '../redux';
import { dialogsState, DialogsState } from '../states/dialogsState';

const dialogsReducer = (state = dialogsState, action: RootActions): DialogsState => {
  switch (action.type) {
    case DialogsActions.OPEN_DIALOG:
      return {
        ...state,
        [action.payload.name]: true,
        data: action.payload.data,
      };
    case DialogsActions.CLOSE_DIALOG:
      return handleCloseDialog(state, action);
    case DialogsActions.CLOSE_DIALOG_WITH_DATA:
      return {
        ...state,
        [action.payload.name]: false,
        data: action.payload.data,
      };
    default:
      return state;
  }
};

export default dialogsReducer;

const specialDialogs = ['orderActionRestrictionDialog'];

function handleCloseDialog(state: DialogsState, action: { type: 'CLOSE_DIALOG'; payload: string }) {
  if (specialDialogs.includes(action.payload)) {
    return {
      ...state,
      [action.payload]: false,
    };
  }
  const { data, ...rest } = state;

  const newState = {
    ...rest,
    [action.payload]: false,
  };

  return newState;
}
